import { ListCard } from "@hagerty/self-service-components";
import styles from "./SettingsSkeleton.module.scss";

const ListCardRowSkeleton = () => (
  <ListCard.Row>
    <div className={styles.sectionDetailRow}>
      <div className={styles.skeleton} />
      <div className={styles.skeleton} />
    </div>
  </ListCard.Row>
);

export function SettingsSkeleton() {
  return (
    <div className="container container_center">
      <ListCard className={styles.container}>
        <ListCardRowSkeleton />
        <ListCardRowSkeleton />
        <ListCardRowSkeleton />
        <ListCardRowSkeleton />
        <ListCardRowSkeleton />
      </ListCard>
    </div>
  );
}
